<div class="row p-1">
  <div class="col-12 pageTitle">
    <h2>&nbsp;&nbsp;Create Template</h2>
  </div>
</div>

<div class="card card-w-title">
  <form [formGroup]="form" (ngSubmit)="save()" appInvalidControlScroll>
    <div class="grid">
      <div class="col-12">
        <div class="p-fluid formgrid grid">
          <div class="field col" style="padding-top: 5px">
            <span class="p-float-label">
              <p-dropdown
                [options]="categories"
                formControlName="notesCategoryId"
                dataKey="categoryId"
                [readonly]="readOnly"
                placeholder="-- Select --"
                optionLabel="categoryName"
              ></p-dropdown>
              <label style="padding-top: 0px">Select Template Category</label>
            </span>
          </div>
          <div class="field col">
            <span class="p-float-label">
              <input
                type="text"
                pInputText
                appFormErrorMessages
                formControlName="templateName"
              />
              <label style="padding-top: 0px">Template Name</label>
            </span>
            <span
              *ngIf="isError"
              class="ui-message ui-message-error ui-corner-all ng-star-inserted"
              >This template name is already taken.Please choose another
              template name
            </span>
          </div>

          <div class="field col">
            <span class="p-float-label">
              <input
                type="text"
                appFormErrorMessages
                pInputText
                formControlName="description"
              />
              <label style="padding-top: 0x">Description</label>
            </span>
          </div>
        </div>
      </div>
    </div>
    <div class="col-12 alignRight">
      <button pButton type="submit">Save Template</button>
      <button
        pButton
        type="button"
        icon="pi pi-check"
        label="Cancel"
        class="p-button-plain GreyButton ml-1"
        (click)="navigateToNoteList()"
      ></button>
    </div>
    <fieldset class="ui-g" style="margin-top: 0px">
      <legend>Template Design</legend>
      <div class="ui-g-12 ui-md-12">
        <div class="carefinity_builder">
            <form-builder (change)="changed($event)"
                          [form]="formioComponents"
                          [options]="builderOptions"
                          class="formio-drag-and-drop"></form-builder>
        </div>
      </div>
    </fieldset>
  </form>
</div>
